import { render, staticRenderFns } from "./ApplicantDetailsForm.vue?vue&type=template&id=441d2f66&"
import script from "./ApplicantDetailsForm.vue?vue&type=script&lang=js&"
export * from "./ApplicantDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports